import angular from 'angular';
import helloPackDeal from './helloPackDeal';
import components from './components';
import './style.scss';

export default angular
  .module('helloPack.scenes.helloPackDeal', [components])
  .component('helloPackDeal', helloPackDeal).name;
